import { useState } from "react";
import { motion } from "framer-motion";
import { CLIENTS } from "@/data/site";

const CATS = ["All", ...Object.keys(CLIENTS)];

function ClientLogo({ name, domain }) {
  const sources = [
    `https://www.google.com/s2/favicons?domain=${domain}&sz=128`,
    `https://icons.duckduckgo.com/ip3/www.${domain}.ico`,
    `https://icons.duckduckgo.com/ip3/${domain}.ico`,
  ];
  const [idx, setIdx] = useState(0);
  const [failed, setFailed] = useState(false);
  return (
    <div
      className="aspect-[3/2] border-r border-b border-[#0A0A14]/12 flex items-center justify-center p-6 group hover:bg-white transition-colors relative overflow-hidden"
      data-testid={`client-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      title={name}
    >
      {!failed ? (
        <img
          src={sources[idx]}
          alt={name}
          loading="lazy"
          onError={() => {
            if (idx < sources.length - 1) setIdx(idx + 1);
            else setFailed(true);
          }}
          className="max-h-12 md:max-h-14 max-w-[70%] object-contain opacity-80 group-hover:opacity-100 transition-all duration-500"
        />
      ) : (
        <span className="font-display text-lg md:text-xl text-[#0A0A14]/55 group-hover:text-[#4B1EAD] text-center transition-colors">
          {name}
        </span>
      )}
    </div>
  );
}

export default function Clients() {
  const [cat, setCat] = useState("All");
  const list = cat === "All" ? Object.values(CLIENTS).flat() : CLIENTS[cat];

  return (
    <section id="clients" className="relative py-32 md:py-48 bg-[#EDE6D2] border-y border-[#0A0A14]/12" data-testid="clients">
      <div className="container-mit">
        <div className="flex items-baseline justify-between mb-14">
          <div>
            <p className="text-[11px] tracking-[0.4em] text-[#A4801C] mb-4">— CLIENT ROSTER</p>
            <h2 className="font-display text-5xl md:text-7xl font-light leading-none text-[#0A0A14]">
              Trusted by 60+ industries.
            </h2>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-10" data-testid="client-filter">
          {CATS.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`client-cat-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className={`px-4 py-2 text-[11px] tracking-[0.2em] uppercase border transition-colors ${
                cat === c
                  ? "border-[#1E1B4B] text-[#05050A] bg-[#1E1B4B]"
                  : "border-[#0A0A14]/18 text-[#0A0A14]/70 hover:border-[#0A0A14]/40 hover:text-[#0A0A14]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <motion.div
          key={cat}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 border-t border-l border-[#0A0A14]/12"
        >
          {list.map((c) => (
            <ClientLogo key={c.name} name={c.name} domain={c.domain} />
          ))}
        </motion.div>
      </div>
    </section>
  );
}
